import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnInit,
} from '@angular/core';
import { OtherService } from 'src/app/Service/other.service';
import { registerables } from 'chart.js';
import { IChart } from '../../pages/fleetdiag-all-items/fleetdiag-all-items.component';
import Chart from 'chart.js/auto';
import zoomPlugin from 'chartjs-plugin-zoom';

@Component({
  selector: 'fleetdiag-dynamic-chart',
  templateUrl: './fleetdiag-dynamic-chart.component.html',
  styleUrls: ['./fleetdiag-dynamic-chart.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FleetdiagDynamicChartComponent implements OnInit {
  chartType: string | number = 0;
  obj: any;
  ctx1: any;
  label: Array<any> = [];
  datachart: Array<any> = [];

  CHART_COLORS: any = {
    green: 'rgb(111, 255, 111)',
    purple: 'rgb(255, 153, 204)',
    blue: 'rgb(29, 179, 214)',
    orange: 'rgb(45, 103, 103)',
    yellow: 'rgb(251, 101, 150)',
    red: 'rgb(36, 123, 46)',
    grey: 'rgb(103, 13, 183)',
  };

  @Input() data!: IChart;
  @Input() chartData: Array<any> = [];

  constructor(public _otherService: OtherService) {
    Chart.register(...registerables);
    Chart.register(zoomPlugin);
  }

  ngOnInit(): void {
    this.chartType = this.data.tiChartType;

    if (this.chartData?.length) {
      this.chartType = 10;
      setTimeout(() => {
        this.initChart();
      }, 100);
    }
  }

  initChart() {
    const fakeEcuData = [
      { X: 1000, Y: 20 },
      { X: 1500, Y: 25 },
      { X: 2000, Y: 32 },
      { X: 2500, Y: 45 },
      { X: 3000, Y: 52 },
      { X: 3500, Y: 48 },
      { X: 4000, Y: 60 },
      { X: 4500, Y: 72 },
      { X: 5000, Y: 65 },
      { X: 5500, Y: 58 },
      { X: 6000, Y: 50 },
    ];

    this.drawChart(this.chartData);
  }

  drawChart(resParse: { X: number; Y: number }[]) {
    this.obj = resParse;

    this.label = [];
    this.datachart = [];

    this.obj.forEach((element: any) => {
      this.label.push(element.X);
      this.datachart.push(element.Y);
    });

    const ctx = document.getElementById(
      `myChart${this.data.strComment}`,
    ) as any;

    if (this.ctx1) {
      this.ctx1.destroy();
    }

    this.ctx1 = new Chart(ctx, {
      type: 'line',

      data: {
        labels: this.label,
        datasets: [
          {
            data: this.datachart,
            borderColor: '#00ffff',
            backgroundColor: '#00ffff10',
            fill: true,
            tension: 0.4,

            pointBackgroundColor: '#00ffff',
            pointBorderColor: '#00ffff',
            pointRadius: 3,
          },
        ],
      },

      options: {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
          mode: 'nearest',
          intersect: false,
        },

        plugins: {
          legend: {
            display: false,
          },

          tooltip: {
            enabled: true,

            backgroundColor: '#0b0f14',
            borderColor: '#00ffff',
            borderWidth: 1,

            titleColor: '#00ffff',
            bodyColor: '#ffffff',

            titleFont: {
              family: 'bYekan',
              size: 13,
            },

            bodyFont: {
              family: 'bYekan',
              size: 12,
            },

            padding: 10,
            displayColors: false,

            callbacks: {
              label: (context) => {
                return `مقدار: ${context.parsed.y}`;
              },
            },
          },

          zoom: {
            zoom: {
              wheel: { enabled: true },
              pinch: { enabled: true },
              mode: 'x',
            },
          },
        },

        scales: {
          x: {
            ticks: {
              color: '#ffffffa9',
              font: {
                family: 'bYekan',
                size: 12,
              },
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1,
            },
          },

          y: {
            ticks: {
              color: '#ffffffa9',
              font: {
                family: 'bYekan',
                size: 12,
              },
            },
            grid: {
              color: '#ffffff10',
              borderColor: '#ffffff60',
              borderWidth: 1,
            },
          },
        },
      },
    });
  }
}
